module.exports = new __parcel__URL__("ADFC.5827f0be.png").toString();